import axios from 'axios';

const TourAvailabilityService = {
  getSchedule(tourId, locationId) {
    return axios({
      method: 'get',
      url: `/api/checkout/experiences/${tourId}/locations/${locationId}/availability`,
    });
  },
  getAvailableDates(tourId) {
    return axios({
      method: 'get',
      url: `/api/tours/${tourId}/available_dates`,
      params: {
        tour_id: tourId,
      },
    });
  },
  getSlotTicketCapacities(tourId, date, time) {
    return axios({
      method: 'get',
      url: '/api/ticket_capacities',
      params: {
        tour_id: tourId,
        date,
        time,
      },
    });
  },
};

export default TourAvailabilityService;
